"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceVariables = void 0;
var replaceVariables = function (text, variables) {
    if (!variables || Object.keys(variables).length === 0)
        return text;
    return text.replace(/\{\{(\w+)\}\}/g, function (_, variableName) {
        return Object.prototype.hasOwnProperty.call(variables, variableName)
            ? String(variables[variableName])
            : "{{".concat(variableName, "}}");
    });
};
exports.replaceVariables = replaceVariables;
